import { FormContextValues, Validate } from '@dreryk/react-common';
import { PasswordInput } from '@dreryk/react-components';

import { nfzLoginTranslationKeys } from '../../../../translations';

const REPEAT_NEW_PASSWORD_FIELD_NAME = 'repeatNewPassword';

const validate: Validate = (data, getValue) => {
   const newPassword = getValue('newPassword');
   if (newPassword !== data) {
      return nfzLoginTranslationKeys.passwordsAreDifferent;
   }

   return undefined;
};

export type RepeatNewPasswordFormBeanPart = { [REPEAT_NEW_PASSWORD_FIELD_NAME]: string | null };

type RepeatNewPasswordFieldProps = Pick<FormContextValues<RepeatNewPasswordFormBeanPart>, 'register'>;

export const RepeatNewPasswordField = (props: RepeatNewPasswordFieldProps): JSX.Element => {
   const controller = props.register(REPEAT_NEW_PASSWORD_FIELD_NAME, {
      required: true,
      validate: validate,
   });

   return (
      <PasswordInput
         label={nfzLoginTranslationKeys.repeatNewPassword}
         controller={controller}
         testId={'repeatNewPassword'}
      />
   );
};
